<aside
  class="hidden lg:flex flex-col h-full bg-white dark:bg-slate-900 border-r border-slate-100 dark:border-slate-800 shrink-0 transition-all duration-300 ease-in-out"
  [class.lg:w-64]="isOpen"
  [class.lg:w-0]="!isOpen"
  [class.lg:overflow-hidden]="!isOpen"
>
  <div class="flex-1 overflow-y-auto px-4 py-5 flex flex-col gap-1">
    <p class="text-[10px] font-semibold text-slate-400 uppercase tracking-[0.15em] px-4 pb-2">
      Menu Principal
    </p>

    @for (item of mainMenu; track item.label) {
      <app-onget-side-bar [item]="item" (click)="onItemClick()"></app-onget-side-bar>
    }

    <div class="mt-auto pt-6">
      <app-button-form
        [fullWidth]="true"
        label="Se déconnecter"
        type="button"
        size="md"
        iconName="log-out"
        (onClick)="toggleModal()"
      ></app-button-form>
    </div>
  </div>
</aside>


<app-modal [isOpen]="showModal()" title="Déconnexion" (close)="toggleModal()">
  <div class="flex flex-col gap-4">
    <p class="text-lg font-semibold text-slate-900 dark:text-white">Se déconnecter</p>
    <p class="text-sm text-slate-500 dark:text-slate-400">Êtes-vous sûr de vouloir vous déconnecter ?</p>
    <div class="flex justify-end gap-3 mt-4">
      <app-button-form
        label="Annuler"
        variant="outline"
        type="button"
        size="md"
        (onClick)="toggleModal()"
      ></app-button-form>
      <app-button-form
        label="Oui, se déconnecter"
        type="button"
        size="md"
        (onClick)="onLogout()"
      ></app-button-form>
    </div>
  </div>
</app-modal>
